<div *ngIf="shouldShowMainComponent(portfolioType)">
    <mat-spinner [diameter]="35" class="mx-auto" *ngIf="shouldShowLoader"></mat-spinner>
    <app-portfolio-preferences-picker #preferencesPickerComponent *ngIf="portfolioPreferences && !shouldShowLoader"
                                      [preferredCategories]="portfolioPreferences.preferredCategories"
                                      [enablePositiveButtonOnChange]="true"
                                      (onPreferredCategoriesChanged)="onSavePreferencesClicked($event)">
        <div heading>Your finzyPRO+ preferences for this portfolio</div>
        <div collapsedPreDescription>The loans that will be picked by finzyPRO+ for this portfolio will be
            limited to the following ratings:
        </div>
        <div collapsedPostDescription *ngIf="isEditable(portfolioRemainingAmount, portfolioCreationDate)">
            If you want to change the rating preference for the remaining amount
            in this portfolio, for loans that will be picked in future, please
            <a [routerLink]="" (click)="preferencesPickerComponent.expand()"><b>click here</b></a>.
        </div>
        <div expandedPreDescription>The loans that will be picked by finzyPRO+ for this portfolio will be
            limited to the following ratings:
        </div>
        <div positiveButtonText>Save Preferences</div>
    </app-portfolio-preferences-picker>
</div>
<div *ngIf="portfolioType === 'reinvest'" class="text-center grey-section p-4">
    Please note that the Master Rating Preference is applied to find loans to reinvest your returns. You can check your
    existing preference or change it for future reinvest cycles in the Master Rating preference selection
    <a [routerLink]="['/preferences']">here</a>.
</div>